// extracted by mini-css-extract-plugin
export var actions = "announcement-module--actions--4zi1j";
export var backdrop = "announcement-module--backdrop--aOxGt";
export var button = "announcement-module--button--PCRWz";
export var close = "announcement-module--close--vey3r";
export var dialog = "announcement-module--dialog--v4rNi";
export var eyebrow = "announcement-module--eyebrow--XwSv2";
export var link = "announcement-module--link--Uggj8";
export var logos = "announcement-module--logos--Bb2Tn";